module.exports = __webpack_public_path__ + "static/metro-834e9ac46ea59805dced5037be43aedf.jpg";